import { CollapseButton } from '@datacamp/le-shared-components';
import React, { useCallback } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const CollapsedSidebar = _ref => {
  let {
    className,
    onClick
  } = _ref;
  const togglePaneVisibility = useCallback(event => {
    event.stopPropagation();
    onClick();
  }, [onClick]);
  return ___EmotionJSX("div", {
    className: className,
    onClick: togglePaneVisibility,
    style: {
      cursor: 'pointer',
      height: '100%',
      position: 'absolute',
      width: '100%'
    }
  }, ___EmotionJSX(CollapseButton, {
    direction: "right"
    // @ts-expect-error waffles-button doesn't expose the MouseEvent in onClick
    ,
    onClick: togglePaneVisibility,
    style: {
      right: '0'
    }
  }));
};